import React from "react";
import { Modal, Box, Typography, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { UpdatePharmacy } from "../pages/switchPharmacyModal/UpdatePharmacy";
import {RBContext} from "../components/RBContext";

interface UpdateLocationModalProps {
  open: boolean;
  handleClose: () => void;
}

export const UpdateLocationModal: React.FC<UpdateLocationModalProps> = ({ open, handleClose }) => {
  const { primaryColor } = React.useContext(RBContext);
  return (
    <Modal open={open} onClose={handleClose} style={{outline: "none"}}>
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          backgroundColor: "#F2F2F2",
          boxShadow: "24px",
          padding: 0,
          borderRadius: 12,
          outline: "none",
          border: "none",
        }}
      >
        <div style={{ backgroundColor: "#FFFFFF", padding: "10px 16px", display: "flex", justifyContent: "space-between", alignItems: "center", borderRadius: "12px 12px 0 0" , border:"none", borderBottom: `1px solid rgb(167, 167, 167)`}}>
          <Typography variant="h6" style={{ color:` ${primaryColor}` }}>Choose your location</Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div style={{height: "calc(100% - 64px)", overflow: "auto"}}>
          <UpdatePharmacy onClose={handleClose} />
        </div>
      </Box>
    </Modal>
  );
};